import create from 'zustand'
import produce from 'immer'
import { differenceBy, flatten } from 'lodash'

export const getProductFiles = (product) => {
    const files = CsvStore.getState().files
    return files.filter((file) => file.product === product)
}

/**
 * @TODO
 * random id for csv key
 * 21 June 2022
 * Remove undeliverable if there no row or merged both files. - Done 21 June 2022
 */

const prepareFile = (files, csv) => {
    /** we will add all files,
     * But before adding any file we need to get all files data merge them in
     * invalid and valids run this sheet data against it
     * and then get unquie values and only add them in it.
     * in this way it will be always unique for among all sheets
     */

    const aggregatedInvalids = flatten(
        files.map((file) => {
            return file.data.invalids
        }),
    )

    const aggregatedValids = flatten(
        files.map((file) => {
            return file.data.valids
        }),
    )

    let valids = csv.data.valids
    let invalids = csv.data.invalids

    if (csv.removedPropertyDuplicates) {
        valids = differenceBy(
            csv.data.valids,
            aggregatedValids,
            (item) => item.propaddres + item.propcity + item.propst,
        )
        invalids = differenceBy(
            csv.data.invalids,
            aggregatedInvalids,
            (item) => item.propaddres + item.propcity + item.propst,
        )
    }

    const data = { valids, invalids }

    return { ...csv, data }
}

export const CsvStore = create((set) => ({
    files: [],
    add: (csv) => {
        set(
            produce((draft) => {
                const files = getProductFiles(csv.product)

                /**
                 * @TODO should we do this in mapping? before sending to API ?
                 */
                const csvToPush =
                    files.length > 0 ? prepareFile(files, csv) : csv
                draft.files.push(csvToPush)
            }),
        )
    },
    remove: (name, product) =>
        set((state) => {
            const files = state.files.filter(
                (file) => !(file.name === name && file.product === product),
            )
            return { files }
        }),
    reset: () => {
        set(
            produce((draft) => {
                draft.files = []
            }),
        )
    },
}))

// produce((draft) => {
//     return draft.files.filter((csv) => csv.name !== name && csv.product !== product)
// }
